import { useQuery } from '@tanstack/react-query';
import { getConsultOptions } from '../api/temporaryUser';
import { VISIT_PATH_OPTIONS } from '../constants/visitPath';
import { CONSULT_METHOD_OPTIONS } from '../constants/consultation';
import { EXERCISE_PURPOSE_OPTIONS } from '../constants/exercisePurpose';

/**
 * 방문경로/상담수단/운동목적 옵션. 백엔드 enum 이 단일 소스이고,
 * 응답 전이나 조회 실패 시에는 하드코딩 상수로 떨어진다.
 */
export const useConsultOptions = () => {
  const { data } = useQuery({
    queryKey: ['consultOptions'],
    queryFn: getConsultOptions,
    staleTime: 1000 * 60 * 60,
  });

  return {
    visitPaths: data?.visitPaths?.length ? data.visitPaths : VISIT_PATH_OPTIONS,
    consultMethods: data?.consultMethods?.length ? data.consultMethods : CONSULT_METHOD_OPTIONS,
    exercisePurposes: data?.exercisePurposes?.length ? data.exercisePurposes : EXERCISE_PURPOSE_OPTIONS,
  };
};

export default useConsultOptions;
